/* eslint-disable */
// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
//   Title,
// } from "chart.js";
// import "./TransBarChart.css";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

// const TransBarChart = ({ data }) => {
//   if (!data) {
//     // return <div>Loading chart...</div>;
//     return (
//       <div className="trans-bar-chart card p-3 text-center" style={{ minHeight: "500px" }}>
//         <div className="d-flex flex-column justify-content-center align-items-center h-100" style={{paddingTop:"200px"}}>
//           <div className="spinner-border text-primary mb-3" role="status"></div>
//           <p style={{ fontSize: "16px", fontWeight: "bold", color: "#0067ac" }}>
//             Loading...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   const { projectedOverall, pipelineOverall, chartProjected } = data;
//   const {
//     projected,
//     pipeline,
//     PO_Received,
//     PO_Awaited,
//     Discussion_Progress,
//     Explored,
//   } = chartProjected;

//   const totals = {
//     projected: projected.reduce((a, b) => a + b, 0),
//     PO_Received: PO_Received.reduce((a, b) => a + b, 0),
//     PO_Awaited: PO_Awaited.reduce((a, b) => a + b, 0),
//     Discussion_Progress: Discussion_Progress.reduce((a, b) => a + b, 0),
//     Explored: Explored.reduce((a, b) => a + b, 0),
//   };

//   const chartData = {
//     labels: ["Q1", "Q2", "Q3", "Q4", "Grand Total"],
//     datasets: [
//       {
//         label: "Projected",
//         backgroundColor: "#2f5597",
//         data: [...projected, totals.projected],
//       },
//       {
//         label: "PO Received",
//         backgroundColor: "#a9c4e3",
//         data: [...PO_Received, totals.PO_Received],
//       },
//       {
//         label: "PO Awaited",
//         backgroundColor: "#196b24",
//         data: [...PO_Awaited, totals.PO_Awaited],
//       },
//       {
//         label: "Discussion in Progress",
//         backgroundColor: "#0f9ed5",
//         data: [...Discussion_Progress, totals.Discussion_Progress],
//       },
//       {
//         label: "To be explored",
//         backgroundColor: "#a02b93",
//         data: [...Explored, totals.Explored],
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: "bottom" },
//       title: {
//         display: true,
//         // text: "Foreign Subsidiaries FY 25-26",
//         text: "Quarter wise entity status",
//         padding: {
//           bottom: 18,
//         },
//       },
//       datalabels: {
//         color: "black",
//         anchor: "end",
//         align: "end",
//         font: { weight: "bold", size: 12 },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: "FTEs Count",
//         },
//       },
//     },
//   };

//   return (
//     <div className="trans-bar-chart card p-3">
//       <div className="summary-container">
//         <div className="summary-card">Projection: {projectedOverall}</div>
//         <div className="summary-card">Pipeline: {pipelineOverall}</div>
//       </div>

//       <h5 className="text-center">FY 25-26</h5>

//       <div className="chart-container" style={{ height: "220px" }}>
//         <Bar data={chartData} options={options} />
//       </div>
//       <table className="table table-bordered table-sm mt-3 text-center">
//         <thead className="table-light">
//           <tr>
//             <th></th>
//             <th>Q1</th>
//             <th>Q2</th>
//             <th>Q3</th>
//             <th>Q4</th>
//             <th>Grand Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           <tr>
//             <td>Projected</td>
//             {[...projected, totals.projected].map((v, i) => (
//               <td key={i}>{v}</td>
//             ))}
//           </tr>
//           <tr>
//             <td>PO Received</td>
//             {[...PO_Received, totals.PO_Received].map((v, i) => (
//               <td key={i}>{v}</td>
//             ))}
//           </tr>
//           <tr>
//             <td>PO Awaited</td>
//             {[...PO_Awaited, totals.PO_Awaited].map((v, i) => (
//               <td key={i}>{v}</td>
//             ))}
//           </tr>
//           <tr>
//             <td>Discussion in Progress</td>
//             {[...Discussion_Progress, totals.Discussion_Progress].map((v, i) => (
//               <td key={i}>{v}</td>
//             ))}
//           </tr>
//           <tr>
//             <td>To be explored</td>
//             {[...Explored, totals.Explored].map((v, i) => (
//               <td key={i}>{v}</td>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default TransBarChart;

// ########################## New Code #############################
// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
//   Title,
// } from "chart.js";
// import "./TransBarChart.css";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

// const colorMap = {
//   projected: "#2f5597",
//   // pipeline: "#196b24",
//   excom_approval_received: "#196b24",
//   excom_awaited: "#196b24",
//   PO_Received: "#a9c4e3",
//   PO_Awaited: "#009688",
//   Discussion_Progress: "#0f9ed5",
//   Explored: "#a02b93",
//   Not_Applicable: "#808080",
//   Dropped: "#f44336",
//   as_null: "#c0c0c0",
// };

// const labelMap = {
//   projected: "Projected",
//   // pipeline: "Pipeline",
//   excom_approval_received: "Excom Approval Received",
//   excom_awaited: "Excom Awaited",
//   PO_Received: "PO Received",
//   PO_Awaited: "PO Awaited",
//   Discussion_Progress: "Discussion in Progress",
//   Explored: "To be Explored",
//   Not_Applicable: "Not Applicable",
//   Dropped: "Dropped",
//   as_null: "As null",
// };

// const TransBarChart = ({ data }) => {
//   if (!data) {
//     return (
//       <div className="trans-bar-chart card p-3 text-center" style={{ minHeight: "500px" }}>
//         <div className="d-flex flex-column justify-content-center align-items-center h-100" style={{ paddingTop: "200px" }}>
//           <div className="spinner-border text-primary mb-3" role="status"></div>
//           <p style={{ fontSize: "16px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   const { projectedOverall, pipelineOverall, chartProjected } = data;

//   const safeArray = (arr) => (Array.isArray(arr) ? arr : [0, 0, 0, 0]);

//   const totals = {};
//   Object.keys(chartProjected).forEach((key) => {
//     totals[key] = safeArray(chartProjected[key]).reduce((a, b) => a + b, 0);
//   });

//   const chartData = {
//     labels: ["Q1", "Q2", "Q3", "Q4", "Grand Total"],
//     datasets: Object.keys(chartProjected).map((key) => ({
//       label: labelMap[key] || key,
//       backgroundColor: colorMap[key] || "#999",
//       data: [...safeArray(chartProjected[key]), totals[key]],
//     })),
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: "bottom" },
//       title: {
//         display: true,
//         text: "Quarter-wise Entity Status",
//         padding: { bottom: 18 },
//       },
//       datalabels: {
//         display: false,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: { display: true, text: "FTE Count" },
//       },
//     },
//   };

//   return (
//     <div className="trans-bar-chart card p-3">
//       <div className="summary-container mb-2">
//         <div className="summary-card">Projection: {projectedOverall}</div>
//         <div className="summary-card">Pipeline: {pipelineOverall}</div>
//       </div>
//       <h5 className="text-center"></h5>
//       <div className="chart-container" style={{ height: "250px" }}>
//         <Bar data={chartData} options={options} />
//       </div>
//       <table className="table table-bordered table-sm mt-3 text-center">
//         <thead className="table-light">
//           <tr>
//             <th>Status</th>
//             <th>Q1</th>
//             <th>Q2</th>
//             <th>Q3</th>
//             <th>Q4</th>
//             <th>Grand Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           {Object.keys(chartProjected).map((key) => (
//             <tr key={key}>
//               <td>{labelMap[key] || key}</td>
//               {[...safeArray(chartProjected[key]), totals[key]].map((v, i) => (
//                 <td key={i}>{v}</td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default TransBarChart;


// ################################
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import "./TransBarChart.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

const colorMap = {
  projected: "#2f5597",
  excom_approval_received: "#196b24",
  excom_awaited: "#23de23ff",
  PO_Received: "#a9c4e3",
  PO_Awaited: "#009688",
  Discussion_Progress: "#0f9ed5",
  Explored: "#a02b93",
  Not_Applicable: "#808080",
  Dropped: "#f44336",
  as_null: "#c0c0c0",
};

const labelMap = {
  projected: "Projected",
  excom_approval_received: "Excom Approval Received",
  excom_awaited: "Excom Awaited",
  PO_Received: "PO Received",
  PO_Awaited: "PO Awaited",
  Discussion_Progress: "Discussion in Progress",
  Explored: "To be Explored",
  Not_Applicable: "Not Applicable",
  Dropped: "Dropped",
  as_null: "As null",
};

const TransBarChart = ({ data }) => {
  if (!data) {
    return (
      <div className="trans-bar-chart card p-3 text-center" style={{ minHeight: "500px" }}>
        <div
          className="d-flex flex-column justify-content-center align-items-center h-100"
          style={{ paddingTop: "200px" }}
        >
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <p style={{ fontSize: "16px", fontWeight: "bold", color: "#0067ac" }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  const { projectedOverall, pipelineOverall, chartProjected } = data;

  const safeArray = (arr) => (Array.isArray(arr) ? arr : [0, 0, 0, 0]);

  const allKeys = [
    "projected",
    "excom_approval_received",
    "excom_awaited",
    "PO_Received",
    "PO_Awaited",
    "Discussion_Progress",
    "Explored",
    "Not_Applicable",
    "Dropped",
    "as_null",
  ];

  const mergedChartData = {};
  allKeys.forEach((key) => {
    mergedChartData[key] = chartProjected[key] || [0, 0, 0, 0];
  });

  const totals = {};
  Object.keys(mergedChartData).forEach((key) => {
    totals[key] = safeArray(mergedChartData[key]).reduce((a, b) => a + b, 0);
  });

  const chartData = {
    labels: ["Q1", "Q2", "Q3", "Q4", "Grand Total"],
    datasets: Object.keys(mergedChartData).map((key) => ({
      label: labelMap[key] || key,
      backgroundColor: colorMap[key] || "#999",
      data: [...safeArray(mergedChartData[key]), totals[key]],
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      // legend: { position: "bottom" },
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 10,
        },
      },
      title: {
        display: true,
        text: "Quarter-wise Entity Status",
        padding: { bottom: 18 },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: "FTE Count" },
      },
    },
  };

  return (
    <div className="trans-bar-chart card p-3">
      <div className="summary-container mb-2">
        <div className="summary-card">Projection: {projectedOverall}</div>
        <div className="summary-card">Pipeline: {pipelineOverall}</div>
      </div>
      <h5 className="text-center"></h5>
      <div className="chart-container" style={{ height: "250px" }}>
        <Bar data={chartData} options={options} />
      </div>
      <table className="table table-bordered table-sm mt-3 text-center">
        <thead className="table-light">
          <tr>
            <th>Status</th>
            <th>Q1</th>
            <th>Q2</th>
            <th>Q3</th>
            <th>Q4</th>
            <th>Grand Total</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(mergedChartData).map((key) => (
            <tr key={key}>
              <td>{labelMap[key] || key}</td>
              {[...safeArray(mergedChartData[key]), totals[key]].map((v, i) => (
                <td key={i}>{v}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransBarChart;
